import { Text } from '@tonic-one/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatTableTopX } from 'src/utils/table';

import { useDashboardServicesStore } from '../../../../models/useDashboardServicesModel';
import { ThreatType } from '../../../../utils/enums';
import { getServiceNamesByValues } from '../../../../utils/service';
import { generateRedirectUrlToLog } from '../../../Log/shared';
import TableTemplate from '../../Charts/TableTemplate';
import DashboardCard from '../../Layout/DashboardCard';
import RedirectLink from '@Components/RedirectLink';
import { LogTypeEnum, SecurityFilterName } from '@Types/log';

function DlpViolatorsByDst(props: { data: any; day: string }) {
  const { t } = useTranslation();
  const servicesModel = useDashboardServicesStore();
  const config = [
    { width: '50%', grow: 1, align: 'left', tooltip: true },
    { width: '30%', grow: 0, align: 'right' },
  ];
  const header = [
    t('dashboard.chart.column.destination'),
    t('dashboard.chart.column.occurrences'),
  ];

  const data = formatTableTopX(
    props.data?.data_protectionCounts?.[props.day]?.recipients,
    ['key', 'doc_count'],
    t
  ).map((row) => [
    row[0],
    row[1] === 0 ? (
      0
    ) : (
      <RedirectLink
        href={`logs?${generateRedirectUrlToLog(
          [
            {
              field: 'threatType',
              values: [ThreatType.DLP],
              type: 'terms',
            },
            {
              field: (row[0] as string).includes('@') ? 'msgTo' : 'folderPath',
              values: [row[0] as string],
              type: 'terms',
            },
            {
              field: 'securityFilterName',
              values: [SecurityFilterName.DLP],
              type: 'terms',
            },
            {
              field: 'scanSource',
              values: getServiceNamesByValues(servicesModel.enabledServices),
              type: 'terms',
            },
          ],
          props.day,
          LogTypeEnum.DETECTION
        )}`}
      >
        <Text>{row[1]}</Text>
      </RedirectLink>
    ),
  ]);

  return (
    <DashboardCard title={t('dashboard.chart.title.dlpViolatorsByDst')}>
      <TableTemplate config={config} header={header} data={data} />
    </DashboardCard>
  );
}

export default React.memo(DlpViolatorsByDst);
